import React, { useState } from "react";

import { MapKind, Region, Canton } from "components";
import { Query, useFetch, useInfiniteFetch, useLocales } from "hooks";
import { FireHistoryTable, HistoryItem } from "./FireHistoryTable";
import { FireHistoryForm, FireHistoryFormProps } from "./FireHistoryForm";

export interface FireHistoryProps {
  type: MapKind;
  cantons: ReadonlyArray<Canton>;
  regionsPath: string;
  filterPath: string;
}

export function FireHistory({
  type,
  cantons,
  regionsPath,
  filterPath,
}: FireHistoryProps): JSX.Element {
  const { t } = useLocales();
  const [query, setQuery] = useState<Query | null>(null);
  const { data: regions } = useFetch<Array<Region>>({ url: regionsPath });
  const { status, data, fetchNextPage, hasNextPage } =
    useInfiniteFetch<HistoryItem>({
      url: filterPath,
      query: query || {},
      options: {
        enabled: Boolean(query),
      },
    });

  const handleSubmit: FireHistoryFormProps["onSubmit"] = (values) => {
    const { levelsOrCategories, ...rest } = values;
    setQuery({
      ...rest,
      [type === "warnMap" ? "levels" : "categories"]: levelsOrCategories,
    });
  };

  return (
    <div className="fire-history">
      <h3>{t("history.title")}</h3>
      <FireHistoryForm
        type={type}
        cantons={cantons}
        onSubmit={handleSubmit}
        regions={regions || []}
      />
      {Boolean(query) && (
        <FireHistoryTable
          loading={status === "loading" || status === "idle"}
          data={data.pages}
          type={type}
          loadMore={hasNextPage && Boolean(data.pages?.length)}
          onLoadMore={fetchNextPage}
        />
      )}
    </div>
  );
}
